"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParcelStrategyType = void 0;
exports.ParcelStrategyType = {
    OneToOne: "ONE_TO_ONE",
    ManyToOne: "MANY_TO_ONE",
};
//# sourceMappingURL=parcel-strategy-type.js.map